import { Avatar, Icon, Tooltip } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
import { SearchUser } from 'lib-search-types';
import { accessControl } from 'lib-shared-access-control';

import { numberFormatterInternational } from '../../../../../app/utils/telephonyHelpers';

import '../../styles/user-item.less';

export type UserItemType = 'new' | 'regular' | 'additional_phone_duplicate';

type PropsT = {
  highlighted: boolean;
  fromNumberFormat: string;
  user: SearchUser;
  canMakeOutBoundCall: boolean;
  makeCall: (user: SearchUser) => Promise<void>;
  editUser: (user: SearchUser) => void;
  userType: UserItemType;
};

const UserItem = ({
  highlighted,
  fromNumberFormat,
  user,
  canMakeOutBoundCall,
  makeCall,
  editUser,
  userType,
}: PropsT) => {
  let name: any = '';
  let isNumberShown = false;
  let avatar = <Avatar user={user} size="32" />;
  let callBtn = (
    <Tooltip content="Phone number needed - click to edit">
      <button
        className="btn btn-link pull-right"
        onClick={() => {
          editUser(user);
        }}
      >
        <Icon name="pen" />
      </button>
    </Tooltip>
  );

  const toPhoneNumberFormat = numberFormatterInternational({
    phoneNumber: user.phone_number,
  } as any);

  if (user.phone_number !== null) {
    // The user has a phone number.
    let editUserRender: JSX.Element | null = null;

    const canEditMembers =
      user.type === 'member' && accessControl.hasAccess('organization.member');

    const canEditContacts =
      user.type === 'contact' && accessControl.hasAccess('conversation.reply');

    if (canEditMembers || canEditContacts) {
      editUserRender = (
        <Tooltip content="Click to edit">
          <button
            className="btn btn-link pull-right edit"
            onClick={() => {
              editUser(user);
            }}
          >
            <Icon name="pen" />
          </button>
        </Tooltip>
      );
    }

    callBtn = (
      <span className="btn-action">
        <Tooltip
          content={`Call ${toPhoneNumberFormat} from ${fromNumberFormat}`}
        >
          <button
            className={
              'btn btn-link pull-right call ' +
              (canMakeOutBoundCall === false ? 'disabled' : '')
            }
            disabled={(canMakeOutBoundCall === false ? 'disabled' : '') as any}
            onClick={
              canMakeOutBoundCall === false
                ? () => {
                    /** Noop. */
                  }
                : () => {
                    makeCall(user);
                  }
            }
          >
            Call
          </button>
        </Tooltip>
        <span
          className={
            userType === 'new' || userType === 'additional_phone_duplicate'
              ? 'hidden'
              : ''
          }
        >
          {editUserRender}
        </span>
      </span>
    );
  }
  if (userType === 'new') {
    avatar = (
      <Avatar
        icon="user-plus"
        color={{
          backgroundColor: colors.neutral[200],
          contentColor: colors.neutral[800],
        }}
        size="32"
      />
    );
  }

  if (typeof user.name === 'string' && user.name.trim().length > 0) {
    name = user.name;
  } else if (typeof user.phone_number === 'string') {
    name = user.phone_number;
    isNumberShown = true;
  } else if (typeof user.email === 'string') {
    name = user.email;
  }
  return (
    <li className={'row-item user ' + (highlighted === true ? 'focused' : '')}>
      <div className="row-item-avatar">{avatar}</div>
      <Tooltip content={name}>
        <span className="user-name">{name}</span>
      </Tooltip>
      <span className="type">
        {isNumberShown === false && user.phone_number !== null
          ? toPhoneNumberFormat
          : 'Contact'}
      </span>
      {callBtn}
    </li>
  );
};

export default UserItem;
